<template>
  <a class="bx-header__logo"
     :title="portalTitle"
     href="/">
    <img :src="`/images/bravo/logo-white-${activePortal}.svg`"
         :alt="`${portalTitle} Logo`">
  </a>
</template>

<script>
import { mapState } from 'pinia'

import { usePageStore } from '../../../stores/page'

export default {
  computed: {
    ...mapState(usePageStore, ['pageData']),
    activePortal () {
      return this.pageData.pageMeta.style ? this.pageData.pageMeta.style : 'bravo'
    },
    portalTitle () {
      const portal = this.activePortal !== 'bravo' ? `/${this.activePortal}` : ''
      return `www.bravo.de${portal}`
    }
  }
}
</script>
